// import moment from 'moment'
import cartServicesMinimal from '@/mixins/services/cartServicesMinimal'

export default {
  mixins: [ cartServicesMinimal ],
  methods: {
    _addToCart (ItemInfo, MediaSerialNumber, MediaUnicity,Usercode) {

    if(!Usercode || Usercode==="")
    {
      Usercode = this.user.UserAccountCode
    }

      return this.$http.post('sales/additem', { MediaSerialNumber, MediaUnicity, ItemInfo, MediaType: ItemInfo.MediaType, UserCode: Usercode, OrderId: this.cart2.OrderId }, this.completeHttpParams({ emulateJSON: false })).then(response => {
        this._getCart(true)
        return response.body
      })
    },
    _emptyCart () {
      return this.$http.delete('sales/clearbasket', this.completeHttpParams({ headers: { UserCode: this.user.UserAccountCode }, emulateJSON: false })).then(response => {
        this._getCart(true)
        return response.body
      })
    },
    /* _updateQuantityInCart (orderItemId, quantity) {
      // cartCache = null
      return this.$http.put('sales/updatebasketquantity', { orderItemId, OrderId: this.cart2.OrderId, quantity },  this.completeHttpParams({ emulateJSON: false })).then(response => {
        let el = this.cart2.OrderItemWebApi.find(el => el.id === orderItemId)
        this.$set(el, 'quantity', quantity)
        return response.body
      })
    }, */


    _removeFromCart (OrderItemId) {
      // cartCache = null
      return this.$http.put('sales/deleteitem', { OrderItemId, OrderId: this.cart2.OrderId }, this.completeHttpParams({ emulateJSON: false })).then(response => {
        let idx = this.cart2.OrderItemWebApi.findIndex(el => el.id === OrderItemId)
        this.cart2.OrderItemWebApi.splice(idx, 1)
        return response.body
      })
    }
  }
}